<template>
  <v-container fluid v-if="user">
    <v-card class="text-center accent-4">
      <v-col>
        <v-card-title class="teal lighten-3 accent-4 white--text mb-4"
          >Cobranza de Vendedor
        </v-card-title>
        <v-row>
          <v-col cols="3" class="ml-4">
            <v-combobox
              v-model="vendedor"
              :items="vendedores"
              label="Vendedor"
              item-text="nombre"
              item-value="id"
              required
            ></v-combobox>
          </v-col>
          <v-col cols="2" class="ml-4">
            <v-select v-model="dia" :items="dias" label="Día"></v-select>
          </v-col>

          <v-col cols="2" class="ml-4">
            <v-btn
              :loading="loadingCobranzaVendedor"
              @click="getCobranzaVendedor"
              class="mt-5"
              >Buscar</v-btn
            >
          </v-col>
        </v-row>
      </v-col>

      <v-row v-if="facturas.length">
        <v-col cols="2" class="ml-4">
          <v-select
            v-model="filtroDias"
            :items="opcionesDias"
            label="Máx días venc."
            clearable
          ></v-select>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="3" class="mr-4 mx-auto">
          <v-btn
            color="primary"
            class="mt-5 mr-2"
            :disabled="!facturas.length"
            @click="exportToExcelCobranzaVendedor"
          >
            Descargar Excel
          </v-btn>
          <v-btn
            color="primary"
            class="mt-5"
            :disabled="!facturas.length"
            @click="imprimirCobranza"
          >
            Imprimir
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="facturasFiltradas"
        :group-by="['razon_social']"
        :footer-props="{ 'items-per-page-text': 'Facturas por página' }"
        :header-props="{ 'sort-by-text': 'Ordenar por' }"
        no-data-text="No se encontraron facturas"
        no-results-text="No se encontraron facturas"
        :items-per-page="15"
        v-if="facturas.length"
        class="mx-2 mt-4"
      >
        <template v-slot:[`group.header`]="item">
          <td :colspan="headers.length">
            <strong>
              {{ item.items[0].codigo_cliente }} - {{ item.group }}
            </strong>

            ({{ item.items.length }} facturas)
            <v-btn icon small @click="item.toggle">
              <v-icon>
                {{ item.isOpen ? "mdi-chevron-down" : "mdi-chevron-right" }}
              </v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.fecha`]="{ item }">
          {{ formatoFecha(item.fecha) }}
        </template>
        <template v-slot:[`item.fecha_vencimiento`]="{ item }">
          {{ formatoFecha(item.fecha_vencimiento) }}
        </template>
        <template v-slot:[`item.total`]="{ item }">
          ${{ item.total.toFixed(2) }}
        </template>
        <template v-slot:[`item.pendiente`]="{ item }">
          ${{ item.pendiente.toFixed(2) }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loadingCobranzaVendedor: false,
      vendedores: [],
      vendedor: null,
      dia: null,
      filtroDias: null,
      opcionesDias: [0, 7, 15, 30, 45, 60, 90],
      dias: [
        { text: "Lunes", value: "lunes" },
        { text: "Martes", value: "martes" },
        { text: "Miércoles", value: "miercoles" },
        { text: "Jueves", value: "jueves" },
        { text: "Viernes", value: "viernes" },
      ],
      facturas: [],
      headers: [
        { text: "Fecha", value: "fecha" },
        { text: "Serie y Folio", value: "serie_folio" },
        { text: "Vencimiento", value: "fecha_vencimiento" },
        { text: "Total", value: "total" },
        { text: "Pendiente", value: "pendiente" },
        { text: "Concepto", value: "concepto" },
        { text: "Cliente", value: "razon_social" },
        { text: "Días para vencimiento", value: "dias_para_vencimiento" },
      ],
    };
  },
  methods: {
    async exportToExcelCobranzaVendedor() {
      const grupos = this.agruparPorCliente();

      this.exportToExcel(grupos, "cobranza", "Cobranza");
    },

    async exportToExcel(data, fileName, sheetName) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(sheetName);

      // Título
      worksheet.mergeCells("A1:H1");
      const titleCell = worksheet.getCell("A1");
      titleCell.value = "Reporte de Cobranza";
      titleCell.font = {
        bold: true,
        size: 16,
      };
      titleCell.alignment = {
        horizontal: "center",
      };

      let rowIndex = 3;

      data.forEach((grupo) => {
        // Cliente
        worksheet.mergeCells(`A${rowIndex}:H${rowIndex}`);
        const clienteCell = worksheet.getCell(`A${rowIndex}`);
        clienteCell.value = `${grupo.codigo_cliente} - ${grupo.razon_social}`;
        clienteCell.font = { bold: true };
        clienteCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "D9D9D9" },
        };

        rowIndex++;

        // Headers
        const headerRow = worksheet.getRow(rowIndex);
        headerRow.values = [
          "Fecha",
          "Factura",
          "Vencimiento",
          "Total",
          "Pendiente",
          "Concepto",
          "Días Venc.",
          "Cliente",
        ];

        headerRow.font = { bold: true };

        rowIndex++;

        // Facturas
        grupo.facturas.forEach((f) => {
          worksheet.getRow(rowIndex).values = [
            f.fecha,
            f.serie_folio,
            f.fecha_vencimiento,
            Number(f.total),
            Number(f.pendiente),
            f.concepto,
            f.dias_para_vencimiento,
            f.razon_social,
          ];

          rowIndex++;
        });

        rowIndex++;
      });

      // Ancho columnas
      worksheet.columns = [
        { width: 15 },
        { width: 20 },
        { width: 18 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 35 },
      ];

      // Bordes
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();

      saveAs(new Blob([buffer]), `${fileName}.xlsx`);
    },

    agruparPorCliente() {
      const grupos = {};

      this.facturas.forEach((factura) => {
        const key = `${factura.codigo_cliente}-${factura.razon_social}`;

        if (!grupos[key]) {
          grupos[key] = {
            codigo_cliente: factura.codigo_cliente,
            razon_social: factura.razon_social,
            facturas: [],
          };
        }

        grupos[key].facturas.push(factura);
      });

      return Object.values(grupos);
    },

    imprimirCobranza() {
      const grupos = this.agruparPorCliente();

      const vendedorNombre = this.vendedor?.nombre || "";
      const fechaActual = moment().locale("es").format("LL");

      let totalGeneral = 0;

      let contenido = `
    <html>
    <head>
      <title>Relación de Cobranza</title>
      <style>
       @page { 
                  size: A4 portrait;
                  margin-top: 0.5mm;
                  margin-left: 0mm;
                  margin-right: 0mm;
                @bottom-center {
                    content: "Página " counter(page) " de " counter(pages);
                        } 
            }
        body {
          font-family: Arial;
          padding: 20px;
          font-size: 12px;
        }

        .titulo {
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        .subtitulo {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 15px;
        }

        th, td {
          border: 1px solid #000;
          padding: 4px;
          font-size: 11px;
        }

        th {
          background: #f0f0f0;
        }

        .cliente {
          background: #ddd;
          font-weight: bold;
          padding: 6px;
          margin-top: 15px;
        }
       .footer-block {
    margin-top: 35px;
    border: 2px solid #000;
    padding: 18px;
    page-break-inside: avoid;
    break-inside: avoid;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .footer-total {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #000;
    padding-bottom: 12px;
  }

  .footer-middle {
    display: flex;
    gap: 15px;
    align-items: flex-start;
  }

  .footer-logo {
    width: 80px;
    flex-shrink: 0;
  }

  .footer-logo img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  .footer-text {
    flex: 1;
    font-size: 11px;
    line-height: 1.5;
    text-align: justify;
  }

  .footer-signatures {
    display: flex;
    justify-content: space-between;
    gap: 25px;
    margin-top: 8px;
  }

  .signature-box {
    width: 45%;
    text-align: center;
  }

  .signature-line {
    margin-top: 45px;
    border-top: 1px solid #000;
    padding-top: 8px;
    font-weight: bold;
  }

        @media print {
          body {
            margin: 0;
          }
             .footer-block {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }
        }
      </style>
    </head>
    <body>
      <div class="titulo">
        RELACIÓN DE COBRANZA - ${vendedorNombre}
      </div>

      <div class="subtitulo">
        <div>Día: ${this.dia.toUpperCase()}</div>
        <div>Sucursal: ${this.vendedor?.sucursal}</div>
        <div>Fecha: ${fechaActual}</div>
      </div>
  `;
      grupos.forEach((grupo) => {
        contenido += `
      <div class="cliente">
        Cliente: ${grupo.codigo_cliente} - ${grupo.razon_social}
        <div>
        Saldo Total: $${grupo.facturas
          .reduce((acc, f) => acc + Number(f.pendiente), 0)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Factura</th>
            <th>Tipo CFDI</th>
            <th>Vencimiento</th>
            <th>Dias</th>
            <th>Importe</th>
            <th>Saldo</th>
            <th>Obs.</th>
          </tr>
        </thead>
        <tbody>
    `;

        grupo.facturas.forEach((f) => {
          totalGeneral += Number(f.pendiente);

          contenido += `
        <tr>
          <td>${moment(f.fecha).locale("es").format("DD/MMMM/YYYY")}</td>
          <td>${f.serie_folio}</td>
          <td>${f.concepto}</td>
          <td>${moment(f.fecha_vencimiento)
            .locale("es")
            .format("DD/MMMM/YYYY")}</td>
          <td>${f.dias_para_vencimiento}</td>
          <td>$${Number(f.total)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
          <td>$${Number(f.pendiente)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
          <td></td>
        </tr>
      `;
        });

        contenido += `
        </tbody>
      </table>
    `;
      });
      contenido += `
      <div class="footer-block">

  <div class="footer-total">
    TOTAL: $${totalGeneral.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
  </div>

  <div class="footer-middle">
    <div class="footer-logo">
      <img src="${require("@/assets/log.png")}" alt="Logo" />
    </div>

    <div class="footer-text">
      <b>Yo: ${this.vendedor?.nombre}</b>, me hago responsable por el resguardo,
      cobranza y/o extravío de las facturas aquí relacionadas y me comprometo a
      entregar pago o devolución de las mismas en tiempo y forma en caso de que
      no sean pagadas por el cliente. Pagaré incondicionalmente a la orden de
      <b>Central Express de Control de Plagas S.A. de C.V.</b>.
    </div>
  </div>

  <div class="footer-signatures">
    <div class="signature-box">
      <div class="signature-line">
        FIRMA
      </div>
    </div>

    <div class="signature-box">
      <div class="signature-line">
        ACEPTO Y PAGARÉ
      </div>
    </div>
  </div>

</div>
      
    </body>
    </html>
  `;

      const ventana = window.open("", "_blank");
      ventana.document.write(contenido);
      ventana.document.close();
      setTimeout(() => ventana.print(), 1000);
    },
    async getVendedores() {
      try {
        const response = await axios.get(`/usuarios/get_usuarios`);

        this.vendedores = response.data.usuarios
          .filter((vendedor) => vendedor.nombre_adminpaq)
          .map((vendedor) => ({
            nombre: vendedor.nombre,
            nombre_adminpaq: vendedor.nombre_adminpaq,
            id: vendedor.id,
            sucursal: vendedor.sucursal,
          }));
      } catch (error) {
        console.error("Error al obtener vendedores:", error);
      }
    },

    async getCobranzaVendedor() {
      if (!this.vendedor || !this.dia) return;

      this.loadingCobranzaVendedor = true;

      try {
        const response = await axios.get(
          `/reportes/get_cobranza_de_vendedor?id_vendedor=${this.vendedor.id}&dia=${this.dia}`,
        );

        const responseData = response.data;

        this.facturas = responseData.data.map((row, i) => ({
          index: responseData.index[i],
          serie: row[0],
          folio: row[1],
          serie_folio: `${row[0]} - ${row[1]}`,
          fecha: row[2],
          fecha_vencimiento: row[3],
          total: row[4],
          pendiente: row[5],
          concepto: row[6],
          razon_social: row[7],
          codigo_cliente: row[8],
          dias_para_vencimiento: row[9],
        }));
      } catch (error) {
        console.error("Error al obtener cobranza de vendedor:", error);
      } finally {
        this.loadingCobranzaVendedor = false;
      }
    },

    formatoFecha(fecha) {
      return moment(fecha).locale("es").format("DD/MM/YYYY");
    },
  },
  watch: {},
  components: {},
  created() {
    this.getVendedores();
  },
  computed: {
    ...mapGetters(["user"]),

    facturasFiltradas() {
      if (this.filtroDias == null) return this.facturas;

      return this.facturas.filter(
        (f) => f.dias_para_vencimiento <= this.filtroDias,
      );
    },
  },
};
</script>
